/**
 * The care-setting benefit blocks of an eligibility response's `details`, the blocks a copay or
 * co-insurance is read from. Mirrors the API's `BENEFIT_BLOCK` in
 * `services/clear-api/src/domains/eligibility/practiceTypes.ts`: when a block is added there, add it here.
 * Plan-level blocks (`HBPC_Deductible_OOP_Summary`) carry no cost share and are deliberately left out.
 */
export const CARE_SETTING_SUMMARY_KEYS = [
  "ASC_FacilitySummary",
  "HospitalOutPatientSummary",
  "HospitalInpatientSummary",
  "SpecialistOfficeSummary",
  "MRI_CT_ScanSummary",
  "SurgicalSummary",
  "XRaySummary",
  "DiagnosticMedicalSummary",
] as const;

const isBlockEmpty = (block: unknown) =>
  block == null ||
  (typeof block === "object" && Object.keys(block as object).length === 0);

/** True when the response carries no care-setting block with anything in it. */
export const areAllCareSettingBlocksEmpty = (
  details: Record<string, unknown> | null | undefined
) => CARE_SETTING_SUMMARY_KEYS.every((key) => isBlockEmpty(details?.[key]));
